import React from 'react';

import { Link } from '@qality/common-components/src/atoms/Link';

import { DownloadLogsStyled } from './DownloadLogs.styled';

export const DownloadLogsView = ({
  handleClick,
}: {
  handleClick: () => void;
}) => {
  return (
    <DownloadLogsStyled>
      <Link onClick={handleClick}>Download logs</Link>
    </DownloadLogsStyled>
  );
};
